import { toast } from "react-toastify";

// helper function to check if a response from database is valid
export async function checkResponse(response, logout) {

  // Check if user is authorized first, if not logout user.
  if (response.status === 401 || response.status === 403) {
    response = await response.json();
    toast.error(response.error);
    logout();
    return false;
  }
  // Check if response is ok, if not show error message.
  else if (!response.ok) {
    response = await response.json();
    let message = `Ett fel hände: ${response.error}`;
    toast.error(message);
    return false;
  }
  return true;
}



